<template>
  <div>
    <p>{{ $t("节点配置") }}</p>

    <t-form-item
      name="newTaskID"
      :required-mark="false"
      :status="isTaskFlowMissing ? 'error' : undefined"
      :help="isTaskFlowMissing ? $t('任务流不存在') : ''"
      :rules="[
        {
          required: true,
          message: $t('不能为空'),
          trigger: 'change',
        },
      ]"
      style="margin-bottom: 12px"
    >
      <template #label>
        <text-with-mark :text="$t('选择任务流')" />
      </template>
      <t-select v-model="formData.newTaskID" :options="taskFlows" filterable />
    </t-form-item>
    <div>
      <span style="color: #6d778c; padding-right: 8px">{{
        $t("将已有的工作流集成到此流程中，执行嵌套任务")
      }}</span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, inject, reactive, Ref, ref, toRefs, watch } from "vue";

type OptionType = Array<{ value: string | number; label: string }>;

const emit = defineEmits(["updateData"]);

const getTaskFlowsFn = inject<Ref<() => Promise<OptionType>>>("getTaskFlows");

type Model = {
  nodeData: {
    newTaskID?: string;
  };
};

const props = defineProps<{
  data: Model["nodeData"];
  visible: boolean;
}>();

const formData = reactive<Model["nodeData"]>({
  newTaskID: props.data.newTaskID ?? "",
});

const taskFlows = reactive<OptionType>([]);
const optionsLoaded = ref(false);

const normalizeTaskId = (taskId?: string | number) =>
  taskId === undefined || taskId === null ? "" : String(taskId).trim();

const isTaskFlowMissing = computed(() => {
  const currentTaskId = normalizeTaskId(formData.newTaskID);

  if (!optionsLoaded.value || !currentTaskId) {
    return false;
  }

  return !taskFlows.some(
    (taskFlow) => normalizeTaskId(taskFlow.value) === currentTaskId,
  );
});

const getOptions = () => {
  if (getTaskFlowsFn?.value) {
    getTaskFlowsFn.value()
      .then((data) => {
        taskFlows.splice(0, taskFlows.length, ...data);
      })
      .finally(() => {
        optionsLoaded.value = true;
      });
  } else {
    optionsLoaded.value = true;
  }
};

watch(formData, (newVal, oldVal) => {
  emit("updateData", newVal);
});

const { visible } = toRefs(props);

watch(
  visible,
  (newVal) => {
    if (newVal) {
      getOptions();
    }
  },
  { immediate: true },
);
</script>
<style lang="less" scoped></style>
